export default "__VITE_PUBLIC_ASSET__435f6137__"